import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useMobileAppBanner } from './useMobileAppBanner';
import { useCommonStore } from '@/store';

export const usePopupHeight = () => {
  const {
    isEmailConfirmationPopup,
    mobileAppPopupHeight,
    emailConfirmationPopupHeight,
  } = useCommonStore(
    useShallow((state) => ({
      isEmailConfirmationPopup: state.isEmailConfirmationPopup,
      mobileAppPopupHeight: state.mobileAppPopupHeight,
      emailConfirmationPopupHeight: state.emailConfirmationPopupHeight,
    }))
  );

  const { isShowMobileAppBanner } = useMobileAppBanner();

  const popupHeight = useMemo(() => {
    if (isEmailConfirmationPopup) {
      return emailConfirmationPopupHeight;
    }

    if (isShowMobileAppBanner) {
      return mobileAppPopupHeight;
    }

    return 0;
  }, [
    emailConfirmationPopupHeight,
    isEmailConfirmationPopup,
    isShowMobileAppBanner,
    mobileAppPopupHeight,
  ]);
  return { popupHeight };
};
